import React from 'react';
import Badge from 'react-bootstrap/Badge';
import './RiskBadge.css';

const levelToVariant = { 
  LOW: 'dark', 
  MODERATE: 'secondary', 
  MEDIUM: 'secondary',
  HIGH: 'danger' 
};

export default function RiskBadge({ level = 'LOW' }) {
  // Handle N/A case
  if (!level || level.toUpperCase() === 'N/A' || level === 'N/A') {
    return (
      <Badge bg="secondary" pill className="risk-badge secondary">
        N/A
      </Badge>
    );
  }

  // Normalize level to uppercase
  const normalizedLevel = level.toUpperCase();
  const variant = levelToVariant[normalizedLevel] || 'dark';
  const displayLevel = normalizedLevel === 'MEDIUM' ? 'MODERATE' : normalizedLevel;
  
  return (
    <Badge bg={variant} pill className={`risk-badge ${variant}`}>
      {displayLevel}
    </Badge>
  );
}

